
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bonuses",
      function () {
        return require("private-next-pages/bonuses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bonuses"])
      });
    }
  